import axios, { AxiosInstance } from 'axios';
import appConfig from './shared/appConfig';

const instance: AxiosInstance = axios.create({
  baseURL: appConfig.REACT_APP_API_URL,
});

export default instance;
